import type Konva from "konva";
import { BOX_SIZE } from "../ui/RemoveIcon";

const RESIZE_ICON_PATH = "M15 3h6v6 M21 3l-7 7 M3 21l7-7 M9 21H3v-6";

export const artworkGroupAnchorStyleFunc = (anchor: Konva.Rect, zoom: number) => {
  // Safety check for zoom to prevent division by zero or invalid values
  const safeZoom = zoom && zoom > 0 ? zoom : 1;

  if (anchor.hasName("bottom-left")) {
    anchor.shadowColor("rgba(0, 0, 0, 0.15)");
    anchor.shadowBlur(4);
    anchor.shadowOffsetY(2);
    anchor.sceneFunc((context, shape) => {
      const width = shape.width();
      const height = shape.height();
      const cr = shape.cornerRadius();
      const radius = typeof cr === "number" ? cr : 8;

      // Calculate box size based on current anchor size (which should already be set by ArtworkGroup)
      // We re-calculate here for padding logic, but use shape.width() for drawing
      const boxSize = Math.max(BOX_SIZE / safeZoom, 24);

      // Shift amount: move outside by half box size + padding (4px unscaled)
      // We push it left (-x) and down (+y)
      const shift = boxSize / 4 + 4 / safeZoom;

      // Also shift the hit region to match visual representation
      anchor.hitFunc(hitContext => {
        hitContext.translate(-shift, shift);
        hitContext.beginPath();
        hitContext.rect(0, 0, width, height);
        hitContext.closePath();
        hitContext.fillStrokeShape(shape);
      });

      // Save context before any transformations
      context.save();
      // Apply offset translation
      context.translate(-shift, shift);

      // --- DRAW BOX BACKGROUND ---
      context.beginPath();
      context.moveTo(radius, 0);
      context.lineTo(width - radius, 0);
      context.arc(width - radius, radius, radius, (Math.PI * 3) / 2, 0, false);
      context.lineTo(width, height - radius);
      context.arc(width - radius, height - radius, radius, 0, Math.PI / 2, false);
      context.lineTo(radius, height);
      context.arc(radius, height - radius, radius, Math.PI / 2, Math.PI, false);
      context.lineTo(0, radius);
      context.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2, false);
      context.closePath();
      context.fillStrokeShape(shape);

      // --- DRAW ICON ---
      const iconSize = 24;
      // Use tight padding (4px) if at min size, otherwise proportional
      const padding = boxSize === 24 ? 4 : 8 / safeZoom;
      const targetIconSize = boxSize - padding;
      const scale = targetIconSize / iconSize;

      const centerX = width / 2;
      const centerY = height / 2;

      context.translate(centerX, centerY);
      context.scale(scale, scale);
      context.translate(-iconSize / 2, -iconSize / 2);

      const path = new Path2D(RESIZE_ICON_PATH);
      context.strokeStyle = "#000000";
      context.lineWidth = 2;
      context.lineCap = "round";
      context.lineJoin = "round";
      context.stroke(path);
      // Restore context to clean up all translations/scales
      context.restore();
    });
  }
};
